var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-app-users-by-campaign-overview',{attrs:{"customer-id":_vm.customerId,"campaign-id":_vm.campaignId}})
}
var staticRenderFns = []

export { render, staticRenderFns }